import { useEffect } from "react";

const IDLE_MS = 5 * 60 * 1000;
const LAST_KEY = "pg_last_activity";

/** Locks the employee identity after 5 minutes without real activity (even while the tab was in the background), when the tab/app is closed, or when connectivity drops. Switching tabs alone never locks. */
export function usePinAutoLock(active, lock) {
  useEffect(() => {
    if (!active) return;
    const now = () => Date.now();
    let last = now();
    let t = setTimeout(lock, IDLE_MS);
    const bump = () => { last = now(); try { sessionStorage.setItem(LAST_KEY, String(last)); } catch {} clearTimeout(t); t = setTimeout(lock, IDLE_MS); };
    const check = () => { if (now() - last >= IDLE_MS) lock(); };  // timers are throttled in background tabs — re-check on return
    const vis = () => { if (document.visibilityState === "visible") check(); };
    const hide = (e) => { if (!e.persisted) lock(); };  // real close/refresh, not a tab switch or bfcache suspension
    const evs = ["pointerdown", "keydown", "touchstart", "wheel", "scroll"];
    evs.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    document.addEventListener("visibilitychange", vis); window.addEventListener("focus", vis); window.addEventListener("pagehide", hide); window.addEventListener("offline", lock);
    return () => { clearTimeout(t); evs.forEach((e) => window.removeEventListener(e, bump)); document.removeEventListener("visibilitychange", vis); window.removeEventListener("focus", vis); window.removeEventListener("pagehide", hide); window.removeEventListener("offline", lock); };
  }, [active, lock]);
}
